import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UtilitiesAddComponent } from '../utilities/utilities-add/utilities-add.component';
import { Router } from '@angular/router';
import { EnergySummaryService } from 'src/app/services/energy-summary.service';
import { UserService } from 'src/app/services/user.service';
import { BaseComponent } from 'src/app/shared/base.component';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardComponent extends BaseComponent implements OnInit {

  utility_count = 0;
  users_count = 0;
  total_installed_capacity = 0;
  total_traded_energy = 0;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private userService: UserService,
    private energyService: EnergySummaryService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.loadDashboardData();
    this.loadSolarCapacity();
    this.loadEnergyTraded();
  }

  private loadEnergyTraded(): void {
    this.energyService.getEnergySummary()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.total_traded_energy = data?.total_platform_purchased?.total_energy || 0;
          this.cdr.markForCheck();
        }
      });
  }

  private loadDashboardData(): void {
    this.userService.getUserCountByType()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          const counts = this.userService.processDashboardCounts(data);
          this.users_count = counts.users_count;
          this.utility_count = counts.utility_count;
          this.cdr.markForCheck();
        }
      });
  }

  private loadSolarCapacity(): void {
    this.userService.getTotalInstalledCapacity()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.total_installed_capacity = data?.total_installed_solar || 0;
          this.cdr.markForCheck();
        }
      });
  }

  public addUtility(): void {
    const dialogRef = this.dialog.open(UtilitiesAddComponent, {
      width: '1000px',
      maxHeight: '90vh',
      panelClass: 'custom-dialog-container',
      disableClose: true,
    });

    dialogRef.afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (result) {
          this.loadDashboardData();
        }
      });
  }

  public viewUtilities(): void {
    this.router.navigate(['admin-dash/utilities']);
  }
}